var React = require('react');

function FeatureTerrainParkLarge (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"164","rx":"82","fill":"#F58021","key":0}),React.createElement("path",{"d":"M122.516 115V46.8438H136.391V103.422H170.891V115H122.516Z","fill":"white","key":1})]);
}

FeatureTerrainParkLarge.defaultProps = {"role":"presentation","viewBox":"0 0 288 164","fill":"none"};

module.exports = FeatureTerrainParkLarge;

FeatureTerrainParkLarge.default = FeatureTerrainParkLarge;
